!(function () {
  'use strict';
  const POPUP = 'popup-component';
  const CLOSE = '[data-popup-close]';
  const FORM = '[data-notification-form]';
  const HEADING = '[data-product-notification-heading]';
  const SUCCESS = 'has-success';
  const HIDDEN = 'hidden';
  const STORAGE_KEY = 'notification_form_id';

  if (customElements.get('product-notification')) return;

  customElements.define(
    'product-notification',
    class extends HTMLElement {
      constructor() {
        super();
        this.notificationForm = this.querySelector(FORM);
        this.preventSubmit = true;
        this.popup = this.closest('dialog');
        this.popupClose = this.popup.querySelector(CLOSE);
      }

      connectedCallback() {
        this.checkState();
        this.notificationForm.addEventListener('submit', (e) => this.notificationSubmitEvent(e));
        this.popupClose.addEventListener('click', () => {
          this.removeStorage();
        });
      }

      checkState() {
        if (window.location.search.indexOf('contact_posted=true') === -1) return;

        let submittedId = null;
        try {
          submittedId = window.sessionStorage ? window.sessionStorage.getItem(STORAGE_KEY) : null;
        } catch (e) {
          submittedId = null;
        }

        if (!submittedId || this.notificationForm.id !== submittedId) return;

        const heading = this.querySelector(HEADING);
        if (heading) heading.classList.add(HIDDEN);
        const host = this.closest(POPUP);
        if (host) host.classList.add(SUCCESS);
        this.popup.removeAttribute('inert');
        if (typeof this.popup.showModal === 'function') {
          this.popup.showModal();
        } else {
          this.popup.setAttribute('open', '');
        }
        this.removeStorage();
      }

      notificationSubmitEvent(e) {
        if (!this.preventSubmit) return;
        e.preventDefault();
        this.removeStorage();
        this.writeStorage();
        this.preventSubmit = false;
        this.notificationForm.submit();
      }

      writeStorage() {
        try {
          if (typeof window.sessionStorage !== 'undefined' && this.notificationForm.id) {
            window.sessionStorage.setItem(STORAGE_KEY, this.notificationForm.id);
          }
        } catch (e) {}
      }

      removeStorage() {
        try {
          if (typeof window.sessionStorage !== 'undefined') {
            window.sessionStorage.removeItem(STORAGE_KEY);
          }
        } catch (e) {}
      }
    }
  );
})();
